// extracted by mini-css-extract-plugin
export default {"wrapper":"y2-z","play":"z2-z"};